import getRandomInt from '../functions/getRandomInt';
import uqnJoin from '../functions/uqnJoin';
import uqnSplit from '../functions/uqnSplit';
//import gcd from '../functions/gcd';
//import getRandomIntArray from '../functions/getRandomIntArray';
function random2203(type) {
    let a, b, c, k;
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(4, 6); // 1-4: a intersect b intersect c unknown. 5: given a intersect b intersect c. 6: mutually exclusive
        if (type == 4) {
            type = getRandomInt(1, 4); // 1: a cap b, 2: a | b, 3: a | b', 4: a' | b
        }
    }
    if (type == 6) {
        a = getRandomInt(1, 9);
        b = getRandomInt(1, 9);
        c = getRandomInt(1, 9);
        while (b + c > 9) {
            b = getRandomInt(1, 9);
            c = getRandomInt(1, 9);
        }
        k = getRandomInt(1, 3);
        return uqnJoin([type, a, b, c, k]);
    }
    else if (type > 0 && type < 6) {
        a = getRandomInt(1, 9);
        b = getRandomInt(1, 9);
        c = getRandomInt(1, 9);
        k = getRandomInt(1, 9);
        return uqnJoin([type, a, b, c, k]);
    }
    else {
        throw ('type out of bounds (1-6)');
    }
}
function check2203(uqn) {
    if (uqn < 10000 || uqn > 69999) {
        return false;
    }
    const [type, a, b, c, k] = uqnSplit(uqn);
    if (a == 0 || b == 0 || c == 0 || k == 0 || type == 0 || type > 6) {
        return false;
    }
    if (type == 6) {
        if (k > 3) {
            return false;
        }
        if (b + c > 9) {
            return false;
        }
    }
    return true;
}
export { random2203 as random, check2203 as check };
